import { footerColumns, siteBrand } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-background-200 bg-secondary-50">
      <div className="mx-auto w-full max-w-page px-4 py-10 md:px-6 md:py-12">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <a href="#focus" className="flex cursor-pointer items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg" />
              </span>
              <span className="font-heading text-xl text-foreground-950">
                {siteBrand.name}
              </span>
            </a>
            <p className="mt-3.5 max-w-sm text-sm leading-relaxed text-foreground-600">
              聚合头版焦点、置顶爆料与今日要闻，用标题加短摘要的方式，让你一屏看清今天谁在顶上、哪条被顶到最前。
            </p>
            <div className="mt-4 flex flex-wrap gap-1.5">
              {["头版焦点", "置顶爆料", "今日要闻", "社区讨论"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-secondary-200 bg-background-50 px-2.5 py-1 text-xs text-secondary-900"
                >
                  #{tag}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-base text-foreground-950">
                <a
                  href="#focus"
                  className="cursor-pointer transition-colors hover:text-primary-600"
                >
                  {column.title}
                </a>
              </h4>
              <ul className="mt-3 flex flex-col gap-2">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-secondary-200 pt-5 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 {siteBrand.name} · 内容以公开信息整理为准，本站为演示用途
          </p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
            <a href="#trust" className="cursor-pointer transition-colors hover:text-primary-600">
              编辑原则
            </a>
            <a href="#trust" className="cursor-pointer transition-colors hover:text-primary-600">
              社区守则
            </a>
            <a href="#trust" className="cursor-pointer transition-colors hover:text-primary-600">
              提交纠错
            </a>
            <span className="flex items-center gap-1">
              <i className="ri-refresh-line" />
              每日 09:00 更新
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}